import React from 'react';
import { Phone, Clock, MapPin, Mail, Send } from 'lucide-react';
import { CHURCH_INFO } from '../config/constants';

const ContactCard = ({
  contactForm,
  setContactForm,
  loading,
  sendMessage,
  showNotification
}) => {

  return (
    <div className="card">
      <div className="card-header">
        <Phone size={32} className="card-icon" />
        <h2 className="card-title">Contact Us</h2>
      </div>

      <div className="contact-info">
        {CHURCH_INFO.address && (
          <div className="contact-info-section">
            <p className="contact-info-header">
              <MapPin size={18} />
              Address:
            </p>
            <p className="contact-info-content">
              {CHURCH_INFO.address.street}<br />
              {CHURCH_INFO.address.city}, {CHURCH_INFO.address.state} {CHURCH_INFO.address.zip}
            </p>
          </div>
        )}

        <div className="contact-info-section">
          {CHURCH_INFO.contact.phone && (
            <p className="contact-info-item">
              <Phone size={18} />
              Phone: {CHURCH_INFO.contact.phone}
            </p>
          )}
          <p className="contact-info-item">
            <Mail size={18} />
            Email: {CHURCH_INFO.contact.email}
          </p>
        </div>

        <div className="contact-info-section">
          <p className="contact-info-header">
            <Clock size={18} />
            Service Times:
          </p>
          <p className="contact-info-content">
            Sunday Morning: {CHURCH_INFO.serviceTimes.sunday}<br />
            Sunday Afternoon: {CHURCH_INFO.serviceTimes.sundayAfternoon}<br />
            Wednesday Prayer: {CHURCH_INFO.serviceTimes.wednesday}
          </p>
        </div>
      </div>
{/* 
      <div>
        <div className="form-group">
          <label className="form-label">
            Your Name:
          </label>
          <input
            type="text"
            value={contactForm.name}
            onChange={(e) => setContactForm({ ...contactForm, name: e.target.value })}
            placeholder="Enter your name"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            Email:
          </label>
          <input
            type="email"
            value={contactForm.email}
            onChange={(e) => setContactForm({ ...contactForm, email: e.target.value })}
            placeholder="Enter your email"
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            Message:
          </label>
          <textarea
            value={contactForm.message}
            onChange={(e) => setContactForm({ ...contactForm, message: e.target.value })}
            rows="4"
            placeholder="How can we help you?"
            className="form-textarea"
          />
        </div>

        <button
          onClick={sendMessage}
          disabled={loading}
          className={`btn ${loading ? '' : 'btn-primary'}`}
        >
          <Send size={20} />
          {loading ? 'Sending...' : 'Send Message'}
        </button>
      </div> */}
    </div>
  );
};

export default ContactCard;
